export default {
     fetchQuiz(state, payload) {
          state.quizzes = payload;
     }
};